import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FooterTableDesktop } from './Desktop';
import { FooterTableMobile } from './Mobile';

export namespace FooterTableTypes {
  export interface Props {
    onSend?: () => void;
    onCancel?: () => void;
  }
}
export const FooterTable = (props: FooterTableTypes.Props) => {
  const responsiveFooter = useBreakpointValue({
    base: <FooterTableMobile {...props} />,
    sm: <FooterTableDesktop {...props} />,
  });

  return responsiveFooter;
};
